import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import appServices from "../../services/app-services/appServices";
import { PostReport } from "../../util/types";

type State = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  postReports: PostReport[]
}

export const initialState: State = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  postReports: [],
}

export const getPostReportList = createAsyncThunk(
  "postReports",
  async (_, thunkAPI: any) => {
    try {
      return await appServices.getPostReportList()
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const postReportsReducer = createSlice({
  name: "postReports",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPostReportList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPostReportList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.postReports = action.payload.post_reports;
      })
      .addCase(getPostReportList.rejected, (state: any, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const { reset } = postReportsReducer.actions;
export default postReportsReducer.reducer;
